/* Rawnaq — theme JS */
(function () {
  'use strict';
  var CFG = window.RAWNAQ || { t: {} };
  var T = CFG.t || {};

  function money(cents) {
    var v = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = CFG.moneyFormat;
    if (fmt && typeof fmt === 'string') {
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, v).replace(/<[^>]+>/g, '');
    }
    return v;
  }
  function store(key, val) {
    try {
      if (arguments.length === 2) { localStorage.setItem(key, JSON.stringify(val)); return val; }
      return JSON.parse(localStorage.getItem(key) || 'null');
    } catch (e) { return arguments.length === 2 ? val : null; }
  }

  /* ---------- Overlays (drawers, fullscreen menu, quick view) ---------- */
  function openOverlay(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 120);
  }
  function closeOverlays() {
    document.querySelectorAll('.dw.is-open, .veil-menu.is-open, .qv.is-open').forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) { e.preventDefault(); closeOverlays(); openOverlay(op.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.classList.contains('dw__veil') || e.target.classList.contains('qv__veil')) closeOverlays();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlays(); });

  /* ---------- Sticky header shadow ---------- */
  var hd = document.querySelector('.hd');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Qty steppers (non-cart) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!btn || btn.hasAttribute('data-cart-qty')) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = (parseInt(input.value, 10) || 1) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(1, val);
  });

  /* ---------- PDP gallery: scroll-snap, rect-based (RTL-safe) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gallery-track]');
    var slides = [].slice.call(gal.querySelectorAll('[data-gallery-slide]'));
    if (!track || !slides.length) return;
    var thumbs = [].slice.call(gal.querySelectorAll('[data-gallery-thumb]'));
    var dots = [].slice.call(gal.querySelectorAll('[data-gallery-dot]'));
    var current = 0;
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var delta = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: 'smooth' });
      mark(i);
    }
    function nearest() {
      var origin = track.getBoundingClientRect().left, best = 0, bd = Infinity;
      slides.forEach(function (s, k) {
        var d = Math.abs(s.getBoundingClientRect().left - origin);
        if (d < bd) { bd = d; best = k; }
      });
      return best;
    }
    var st = null;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(nearest()); }, 90); }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    gal.querySelectorAll('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(current - 1); }); });
    gal.querySelectorAll('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(current + 1); }); });
    /* zoom toggle */
    slides.forEach(function (s) {
      var z = s.closest('[data-zoom]') || (gal.hasAttribute('data-zoom') ? s : null);
      if (z) s.addEventListener('click', function () { s.classList.toggle('is-zoom'); });
    });
    gal.goToMedia = function (mediaId) {
      if (mediaId == null) return;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].getAttribute('data-media-id') === String(mediaId)) { goTo(k); return; }
      }
    };
  });

  /* ---------- Variants ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = [];
    try {
      var vEl = form.querySelector('[data-variants]');
      variants = JSON.parse((vEl ? vEl.textContent : '[]') || '[]');
    } catch (err) { variants = []; }
    var idInput = form.querySelector('[name="id"]');
    var scope = form.closest('[data-product-scope]') || document;
    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var active = group.querySelector('[data-value].is-active');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }
    function update() {
      var opts = selectedOptions();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      scope.querySelectorAll('[data-product-price]').forEach(function (el) {
        var html = '<span>' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<ins>' + money(v.price) + '</ins> <del>' + money(v.compare_at_price) + '</del>';
        }
        el.innerHTML = html;
      });
      scope.querySelectorAll('[data-atc]').forEach(function (atc) {
        var span = atc.querySelector('span');
        if (v.available) { atc.removeAttribute('disabled'); span && (span.textContent = atc.getAttribute('data-add-label')); }
        else { atc.setAttribute('disabled', ''); span && (span.textContent = atc.getAttribute('data-sold-label')); }
      });
      if (v.media_id != null) {
        var gal = scope.querySelector('[data-gallery]');
        if (gal && gal.goToMedia) gal.goToMedia(v.media_id);
      }
    }
    form.querySelectorAll('[data-option-index] [data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var lbl = group.querySelector('[data-option-selected]');
        if (lbl) lbl.textContent = btn.getAttribute('data-value');
        update();
      });
    });
  });

  /* ---------- Cart ---------- */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
    });
  }
  function renderFree(total) {
    var box = document.querySelector('[data-freebar]');
    if (!box) return;
    var goal = CFG.freeGoal || 0;
    if (!goal || !CFG.freeBar) { box.hidden = true; return; }
    box.hidden = false;
    var txt = box.querySelector('[data-freebar-text]');
    var fill = box.querySelector('[data-freebar-fill]');
    var pct = Math.min(100, Math.round((total / goal) * 100));
    if (fill) fill.style.width = pct + '%';
    if (txt) {
      if (total >= goal) { txt.textContent = T.freeDone || ''; txt.classList.add('is-done'); }
      else {
        txt.innerHTML = (T.freeLeft || '[amount]').replace('[amount]', '<strong>' + money(goal - total) + '</strong>');
        txt.classList.remove('is-done');
      }
    }
  }
  function renderCart(showToast) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderFree(cart.total_price);
      var toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.hidden = !showToast;
        if (showToast) setTimeout(function () { toast.hidden = true; }, 3400);
      }
      var upsell = document.querySelector('[data-upsell]');
      if (upsell) {
        var inCart = cart.items.map(function (i) { return i.handle; });
        upsell.querySelectorAll('[data-upsell-handle]').forEach(function (u) {
          u.hidden = inCart.indexOf(u.getAttribute('data-upsell-handle')) > -1;
        });
        upsell.hidden = cart.item_count === 0 || !upsell.querySelector('[data-upsell-handle]:not([hidden])');
      }
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p class="muted">' + (T.empty || '') + '</p><a class="b b--night" href="/collections/all">' + (T.shopNow || '') + '</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      var html = '';
      cart.items.forEach(function (it) {
        html += '<div class="cline" data-key="' + it.key + '">' +
          '<a class="cline__img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '&width=176" alt="" loading="lazy" onerror="this.src=\'' + it.image + '\'">' : '') + '</a>' +
          '<div><a class="cline__title" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<span class="cline__var">' + it.variant_title + '</span>' : '') +
          '<span class="cline__price">' + money(it.final_line_price) + '</span>' +
          '<div class="cline__row"><div class="stepper" data-qty>' +
          '<button type="button" data-qty-plus data-cart-qty="' + it.key + '" data-dir="1" aria-label="+"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '<input type="text" value="' + it.quantity + '" readonly aria-label="qty">' +
          '<button type="button" data-qty-minus data-cart-qty="' + it.key + '" data-dir="-1" aria-label="-"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg></button>' +
          '</div><button type="button" class="cline__rm" data-cart-remove="' + it.key + '">' + (T.remove || '') + '</button></div>' +
          '</div></div>';
      });
      body.innerHTML = html;
      var totalEl = document.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = money(cart.total_price);
      var noteArea = document.querySelector('[data-cart-note]');
      if (noteArea && !noteArea.matches(':focus')) noteArea.value = cart.note || '';
    });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      refreshCount();
      if (CFG.cartType === 'page') { window.location.href = '/cart'; return; }
      closeOverlays(); renderCart(true); openOverlay('#CartDrawer');
    }).catch(function () {});
  }
  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { refreshCount(); renderCart(false); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    addToCart(id, q ? parseInt(q.value, 10) : 1);
  });
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.getAttribute('data-quick-add'), 1); return; }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { changeCart(rm.getAttribute('data-cart-remove'), 0); return; }
    var cq = e.target.closest('[data-cart-qty]');
    if (cq) {
      var line = cq.closest('.cline');
      var input = line.querySelector('input');
      var val = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(cq.getAttribute('data-dir'), 10));
      changeCart(cq.getAttribute('data-cart-qty'), val);
    }
  });
  document.querySelectorAll('[data-open="#CartDrawer"]').forEach(function (b) {
    b.addEventListener('click', function () { renderCart(false); });
  });
  if (document.querySelector('[data-cart-body]')) renderCart(false);
  var noteArea = document.querySelector('[data-cart-note]');
  if (noteArea) {
    var nt = null;
    noteArea.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteArea.value }) });
      }, 600);
    });
  }

  /* ---------- Wishlist ---------- */
  var WKEY = 'rawnaq_wishlist';
  function wishList() { return store(WKEY) || []; }
  function wishHas(h) { return wishList().some(function (i) { return i.handle === h; }); }
  function wishRender() {
    var list = wishList();
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = list.length; el.hidden = list.length === 0; });
    document.querySelectorAll('[data-wish-toggle]').forEach(function (b) {
      b.classList.toggle('is-active', wishHas(b.getAttribute('data-handle')));
    });
    var body = document.querySelector('[data-wish-body]');
    if (body) {
      if (!list.length) body.innerHTML = '<p class="muted center" style="padding-block:2.4rem">' + (T.wishEmpty || '') + '</p>';
      else body.innerHTML = list.map(function (i) {
        return '<div class="witem"><a href="' + i.url + '">' + (i.img ? '<img src="' + i.img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a class="witem__t" href="' + i.url + '">' + i.title + '</a><div class="witem__p">' + i.price + '</div></div>' +
          '<button type="button" class="witem__x" data-wish-remove="' + i.handle + '" aria-label="x"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      }).join('');
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wish-toggle]');
    if (t) {
      e.preventDefault();
      var h = t.getAttribute('data-handle');
      var list = wishList();
      if (wishHas(h)) list = list.filter(function (i) { return i.handle !== h; });
      else list.push({ handle: h, title: t.getAttribute('data-title'), url: t.getAttribute('data-url'), img: t.getAttribute('data-img'), price: t.getAttribute('data-price') });
      store(WKEY, list); wishRender(); return;
    }
    var r = e.target.closest('[data-wish-remove]');
    if (r) { store(WKEY, wishList().filter(function (i) { return i.handle !== r.getAttribute('data-wish-remove'); })); wishRender(); }
  });
  wishRender();

  /* ---------- Recently viewed ---------- */
  var RKEY = 'rawnaq_recent';
  var saveEl = document.querySelector('[data-recent-save]');
  if (saveEl) {
    try {
      var p = JSON.parse(saveEl.textContent);
      var rl = (store(RKEY) || []).filter(function (i) { return i.handle !== p.handle; });
      rl.unshift(p);
      store(RKEY, rl.slice(0, 12));
    } catch (e) {}
  }
  document.querySelectorAll('[data-recent-rail]').forEach(function (rail) {
    var exclude = rail.getAttribute('data-exclude');
    var list = (store(RKEY) || []).filter(function (i) { return i.handle !== exclude; });
    var section = rail.closest('[data-recent-section]');
    if (!list.length) { if (section) section.hidden = true; return; }
    if (section) section.hidden = false;
    rail.innerHTML = list.map(function (i) {
      return '<div class="pcard"><a class="pcard__media" href="' + i.url + '">' + (i.img ? '<img src="' + i.img + '" alt="" loading="lazy" style="--ratio:3/4">' : '') + '</a>' +
        '<div class="pcard__body"><h3 class="pcard__title"><a href="' + i.url + '">' + i.title + '</a></h3><span class="price">' + i.price + '</span></div></div>';
    }).join('');
  });

  /* ---------- Swatches (card image swap) ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.pcard');
    var img = card && card.querySelector('.pcard__media .pcard__main');
    var src = sw.getAttribute('data-swatch');
    if (img && src) {
      img.removeAttribute('srcset');
      img.src = src;
      card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    }
  });

  /* ---------- Quick view ---------- */
  var qv = document.getElementById('QuickView');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b || !qv) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-view');
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
      var opts = '';
      if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
        p.options.forEach(function (name, oi) {
          var vals = [];
          p.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
          opts += '<div class="optset" data-option-index="' + oi + '"><p class="optset__label"><span>' + name + ': <strong data-option-selected>' + p.variants[0].options[oi] + '</strong></span></p><div class="optset__vals">' +
            vals.map(function (val, k) {
              var avail = p.variants.some(function (v) { return v.options[oi] === val && v.available; });
              return '<button type="button" class="optv' + (val === p.variants[0].options[oi] ? ' is-active' : '') + (avail ? '' : ' is-unavailable') + '" data-value="' + val + '">' + val + '</button>';
            }).join('') + '</div></div>';
        });
      }
      var priceHtml = p.compare_at_price && p.compare_at_price > p.price
        ? '<ins>' + money(p.price) + '</ins> <del>' + money(p.compare_at_price) + '</del>'
        : '<span>' + money(p.price) + '</span>';
      qv.querySelector('[data-qv-content]').innerHTML =
        '<div class="qv__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
        '<div class="qv__body" data-product-scope>' +
        '<h3 class="qv__title">' + p.title + '</h3>' +
        '<div class="pdp__priceline" data-product-price style="margin-bottom:.4rem;padding-bottom:.9rem">' + priceHtml + '</div>' +
        '<form data-product-form class="qv__opts"><script type="application/json" data-variants>' +
        JSON.stringify(p.variants.map(function (v) { return { id: v.id, available: v.available, price: v.price, compare_at_price: v.compare_at_price, options: v.options, media_id: null }; })) +
        '<\/script><input type="hidden" name="id" value="' + p.variants[0].id + '">' + opts +
        '<button type="submit" class="b b--solid b--wide" data-atc data-add-label="' + (T.addToCart || '') + '" data-sold-label="' + (T.soldOut || '') + '"' + (p.available ? '' : ' disabled') + '><span>' + (p.available ? (T.addToCart || '') : (T.soldOut || '')) + '</span></button></form>' +
        '<a class="lnk qv__full" href="' + b.getAttribute('data-quick-view') + '">' + (T.view || '') + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M19 12H5m7-7l-7 7 7 7"/></svg></a></div>';
      bindQuickForm(qv);
      openOverlay('#QuickView');
    }).catch(function () { window.location.href = url; });
  });
  function bindQuickForm(root) {
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      var variants = [];
      try { variants = JSON.parse(form.querySelector('[data-variants]').textContent || '[]'); } catch (e) {}
      var idInput = form.querySelector('[name="id"]');
      var scope = form.closest('[data-product-scope]') || root;
      form.querySelectorAll('[data-option-index] [data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-unavailable')) return;
          var group = btn.closest('[data-option-index]');
          group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var lbl = group.querySelector('[data-option-selected]');
          if (lbl) lbl.textContent = btn.getAttribute('data-value');
          var opts = [];
          form.querySelectorAll('[data-option-index]').forEach(function (g) {
            var a = g.querySelector('[data-value].is-active');
            opts[parseInt(g.getAttribute('data-option-index'), 10)] = a ? a.getAttribute('data-value') : null;
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
          if (!v) return;
          idInput.value = v.id;
          scope.querySelectorAll('[data-product-price]').forEach(function (el) {
            el.innerHTML = v.compare_at_price && v.compare_at_price > v.price
              ? '<ins>' + money(v.price) + '</ins> <del>' + money(v.compare_at_price) + '</del>'
              : '<span>' + money(v.price) + '</span>';
          });
          scope.querySelectorAll('[data-atc]').forEach(function (atc) {
            var span = atc.querySelector('span');
            if (v.available) { atc.removeAttribute('disabled'); span && (span.textContent = atc.getAttribute('data-add-label')); }
            else { atc.setAttribute('disabled', ''); span && (span.textContent = atc.getAttribute('data-sold-label')); }
          });
        });
      });
    });
  }

  /* ---------- Sticky mobile ATC ---------- */
  var matc = document.querySelector('[data-matc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (matc && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      matc.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
    var sBtn = matc.querySelector('[data-matc-submit]');
    sBtn && sBtn.addEventListener('click', function () {
      var form = document.querySelector('section [data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- Share ---------- */
  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || location.href;
      var title = btn.getAttribute('data-title') || document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        var span = btn.querySelector('span');
        if (span) { var old = span.textContent; span.textContent = T.copied || '✓'; setTimeout(function () { span.textContent = old; }, 1500); }
      }).catch(function () {});
    });
  });

  /* ---------- Rails ---------- */
  document.querySelectorAll('.railbox').forEach(function (wrap) {
    var rail = wrap.querySelector('.rail, .cats__rail');
    var bar = wrap.querySelector('.rail-line__bar');
    if (!rail) return;
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      bar.style.width = (max > 0 ? Math.max(12, (Math.abs(rail.scrollLeft) / max) * 100) : 100) + '%';
    }
    rail.addEventListener('scroll', upd, { passive: true }); upd();
    wrap.querySelectorAll('[data-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); }); });
    wrap.querySelectorAll('[data-rail-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); }); });
  });

  /* ---------- Predictive search ---------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (psForm) {
    var input = psForm.querySelector('[data-predictive-input]');
    var results = psForm.parentElement.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var t = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive]');
            results.innerHTML = inner ? inner.innerHTML : '';
          }).catch(function () {});
      }, 220);
    });
  });

  /* ---------- Facets sort / address delete ---------- */
  document.querySelectorAll('[data-facets-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () { var f = sel.closest('form'); if (f) f.submit(); });
  });
  document.querySelectorAll('[data-address-delete]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!confirm(btn.getAttribute('data-confirm') || '?')) return;
      var f = document.createElement('form');
      f.method = 'post'; f.action = btn.getAttribute('data-address-delete');
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f); f.submit();
    });
  });

  /* ---------- Hero slideshow (optional multiple slides) ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var dots = [].slice.call(root.querySelectorAll('[data-slide-dot]'));
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (timer) clearInterval(timer); if (interval > 0) timer = setInterval(function () { show(i + 1); }, interval); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    show(0); start();
  });

  refreshCount();
})();
